<!--
search-input

名称：关键字查询
描述：模糊查询。查询的参数为 keyword
手册：/doc/guide/ListPageQuery.md#15-模糊查询-SearchInput

//-->
<template>
  <div class="search-input-component">
    <el-input
      v-model.trim="keyword"
      class="search-input-component"
      :placeholder="placeholder"
      clearable
      @clear="handleClear"
      @keyup.enter.native="_triggerSearchEvent"
    >
      <el-button v-if="!isEmptyObject(keyword)" slot="append" icon="el-icon-search" @click="_triggerSearchEvent"></el-button>
    </el-input>
  </div>
</template>

<script>
import { ApiSearching } from '@/constants/bus_event'
import SearchMixin from '@/mixins/search'

export default {
  mixins: [SearchMixin],
  model: {
    prop: 'value',
    event: 'search'
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    /**
     * 通讯的总线
     */
    bus: {
      type: Object,
      default: () => null
    },
    /**
     * 属性名
     */
    propName: {
      type: String,
      default: 'keyword'
    }
  },
  data() {
    return {
      keyword: ''
    }
  },
  watch: {
    value(newValue) {
      this.keyword = newValue
    }
  },
  created: function() {
    // Api 搜索启动后，响应（除了响应的方法，其他的基本已经不需要）
    if (this.bus) this.bus.$on(ApiSearching, this._apiSearchingProcess)
  },
  destroyed() {
    if (this.bus) this.bus.$off(ApiSearching, this._apiSearchingProcess)
  },
  mounted() {
    this.keyword = this.value
  },
  methods: {
    _triggerSearchEvent() {
      let params = {}
      params[this.propName] = this.keyword

      this.emitApiParamsChanged(this.bus, params, 'SearchInput') // 主动通过 bus 向 datasource 沟通变化
      this.$emit('search', this.keyword)
    },
    render(keyword) {
      this.keyword = keyword
    },
    /**
     * API 搜索的同步
     *
     * @param {object} search 搜索
     * @param {object} search.pagination 分页信息
     *   格式：{page, perPage}
     */
    _apiSearchingProcess({ params, updatedParamsKeys }) {
      if (updatedParamsKeys.includes(this.propName)) {
        this.keyword = params[this.propName] || ''
      }
    },
    /**
     * 清空输入信息
     */
    handleClear() {
      this._triggerSearchEvent()
    }
  }
}
</script>

<style lang="scss">
.search-condition {
  .search-input-component {
    min-width: 200px;
    width: 200px;
  }
}
.search-input-component {
  min-width: 250px;
}
</style>
